module.exports = __webpack_public_path__ + "img/cloth_g3_item-12.76ea1f2f.svg";